import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import '../publicaciones-home/ads.css';
import moment from 'moment-timezone';
import { 
  Card, CardMedia, CardContent, MobileStepper, IconButton, Button, Box, TextField, } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight, CalendarMonthOutlined, AccessAlarmsOutlined, AddOutlined, Delete } from '@mui/icons-material';

const PublicacionPreview = ({
  evento,
  formData,
  onFormDataChange,
  mediaUrls,
  onAddMedia,
  onDeleteMedia
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { i18n } = useTranslation("global");
  const [isUploading, setIsUploading] = useState(false);

  moment.locale(i18n.language === "es" ? "es" : "en-gb");

  const maxSteps = mediaUrls.length;

  React.useEffect(() => {
    if (mediaUrls.length === 0) {
      setActiveIndex(0);
    } else if (activeIndex >= mediaUrls.length) {
      setActiveIndex(mediaUrls.length - 1);
    }
  }, [mediaUrls.length, activeIndex]);

  const next = () => {
    const nextIndex = activeIndex === mediaUrls.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    const nextIndex = activeIndex === 0 ? mediaUrls.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const handleInputChange = (field, value) => {
    onFormDataChange({ ...formData, [field]: value });
  };

  const handleAddFileClick = async () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*,video/*";
    fileInput.multiple = true;
    fileInput.onchange = async (e) => {
      const files = Array.from(e.target.files);
      if (files.length > 0) {
        setIsUploading(true);
        try {
          await onAddMedia(files);
        } catch (error) {
          console.error("Error uploading files:", error);
        } finally {
          setIsUploading(false);
        }
      }
    };
    fileInput.click();
  };

  // seccion attachs
  const renderMediaSection = () => {
    if (isUploading) {
      return (
        <Box
          sx={{
            width: "370px",
            height: "100%",
            backgroundColor: "#f5f5f5",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            border: "2px dashed #ccc",
            borderRadius: "8px"
          }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Subiendo...</span>
          </div>
          <p style={{ color: "#666", textAlign: "center", margin: "10px 0 0 0" }}>
            Subiendo imágenes...
          </p>
        </Box>
      );
    }

    if (mediaUrls.length === 0) {
      return (
        <Box
          sx={{
            width: "370px",
            height: "100%",
            backgroundColor: "#f5f5f5",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            border: "2px dashed #ccc",
            borderRadius: "8px",
            cursor: "pointer",
            '&:hover': { backgroundColor: "#f0f0f0" }
          }}
          onClick={handleAddFileClick}
        >
          <AddOutlined sx={{ fontSize: "3rem", color: "#666", mb: 1 }} />
          <p style={{ color: "#666", textAlign: "center", margin: 0 }}>
            Haz clic para agregar imágenes
          </p>
        </Box>
      );
    }

    return (
      <div style={{ position: 'relative', height: "100%" }}>
        <CardMedia
          sx={{
            width: "370px",
            height: "100%",
            objectFit: "cover"
          }}
          className="media-publicacion-indiv"
          component="img"
          src={mediaUrls[activeIndex]}
          alt="Preview"
        />

        {/* carousel */}
        {maxSteps > 1 && (
          <>
            <IconButton
              style={{
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                color: "#5656FF"
              }}
              onClick={previous}
              disabled={mediaUrls.length === 0}
            >
              <KeyboardArrowLeft />
            </IconButton>
            <IconButton
              style={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                color: "#5656FF"
              }}
              onClick={next}
              disabled={mediaUrls.length === 0}
            >
              <KeyboardArrowRight />
            </IconButton>
            <MobileStepper
              steps={maxSteps}
              position="static"
              activeStep={activeIndex}
              style={{
                background: 'transparent',
                position: 'absolute',
                bottom: 0,
                width: '100%',
              }}
              nextButton={<div />}
              backButton={<div />}
            />
          </>
        )}

        <IconButton
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            backgroundColor: 'rgba(255,255,255,0.8)',
            color: '#ff4757'
          }}
          onClick={() => onDeleteMedia(activeIndex)}
          size="small"
        >
          <Delete />
        </IconButton>

        <IconButton
          style={{
            position: 'absolute',
            top: 8,
            left: 8,
            backgroundColor: 'rgba(255,255,255,0.8)',
            color: '#5656FF'
          }}
          onClick={handleAddFileClick}
          size="small"
        >
          <AddOutlined />
        </IconButton>
      </div>
    );
  };

  return (
    <div className="mt-4 mx-0 contenedor-card" style={{ /* display: "flex", justifyContent: "center" */ }}>
      <Card
        className="card-publicacion-indiv"
        sx={{
          boxShadow: 'none',
          borderRadius: "10px",
          padding: "5px",
          cursor: "default"
        }}
      >
        <div style={{ position: 'relative', height: "100%", maxHeight: "370px" }}>
          {renderMediaSection()}
        </div>

        <CardContent className="contenido-publicacion-indiv">
          <TextField
            fullWidth
            variant="standard"
            value={formData.titulo || ""}
            onChange={(e) => handleInputChange('titulo', e.target.value)}
            placeholder="Título de la publicación"
            inputProps={{ 
              maxLength: 50,
              style: { 
                fontSize: "24px",
                fontWeight: "600",
              }
            }}
            sx={{
              '& .MuiInput-underline:before': { borderBottomColor: 'transparent' },
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#5656FF' },
              '& .MuiInput-underline:after': { borderBottomColor: '#5656FF' },
            }}
          />

          {/* Fecha y hora del evento, no se puede editar ya que usa la info del evento */}
          <div className="d-flex justify-content-between align-items-center mb-1">
            <div className="fechaHora-publicacion">
              <div className="fecha-publicacion d-flex align-items-center">
                <CalendarMonthOutlined fontSize="small" sx={{ marginRight: "5px" }} />
                <small>
                  {evento?.fechas?.[0]?.fecha
                    ? moment(evento.fechas[0].fecha).format("D [de] MMM")
                    : "Fecha del evento"
                  }
                </small>
              </div>
              <div className="d-flex align-items-center">
                <AccessAlarmsOutlined fontSize="small" sx={{ marginRight: "5px" }} />
                <small>
                  {evento?.fechas?.[0]?.hora_inicio
                    ? moment(evento.fechas[0].hora_inicio).format('LT')
                    : "Hora del evento"
                  }
                </small>
              </div>
            </div>
          </div>

          <p className="mb-0">
            Lugar: {evento?.direccion || "Dirección del evento"}
          </p>

          <div style={{ position: 'relative', marginBottom: '20px' }}>
            <textarea
              value={formData.descripcion || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 85) {
                  handleInputChange('descripcion', value);
                }
              }}
              placeholder="Descripción del evento"
              maxLength={85}
              rows={2}
              style={{
                width: '100%',
                border: 'none',
                borderBottom: '1px solid #ccc',
                outline: 'none',
                fontSize: '16px',
                fontFamily: 'Bricolage Grotesque',
                padding: '4px 0',
                resize: 'none',
                backgroundColor: 'transparent'
              }}
              onFocus={(e) => {
                e.target.style.borderBottom = '2px solid #5656FF';
              }}
              onBlur={(e) => {
                e.target.style.borderBottom = '1px solid #ccc';
              }}
            />
            <small 
              style={{ 
                position: 'absolute', 
                bottom: '-18px',
                right: '0px', 
                color: (formData.descripcion?.length || 0) > 85 ? '#ff4757' : '#666',
                fontSize: '10px'
              }}
            >
              {formData.descripcion?.length || 0}/85
            </small>
          </div>

          <div>
            <div className="d-flex align-items-center justify-content-end gap-3">
              <Button
                sx={{
                  fontSize: '16px',
                  padding: '8px 15px',
                  backgroundColor: '#5656FF',
                  color: 'white',
                  borderRadius: '8px',
                  '&:hover': {
                    backgroundColor: '#3939AA',
                  },
                }}
              >
                Ver más
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PublicacionPreview;